<template>
  <div
    :class="[
      'EdroneTabGroup tw:flex tw:w-fit tw:max-w-full tw:items-center tw:overflow-x-auto',
      type === 'underline' ? 'tw:h-8 tw:sm:min-h-14 tw:w-full tw:border-b tw:border-default-200' : '',
      type === 'border'
        ? 'tw:min-h-10 tw:bg-default-000 tw:border tw:border-default-200 tw:rounded-sm tw:overflow-hidden tw:[&>*]:shadow-none tw:[&>*:not(:last-child)]:border-r tw:[&>*]:border-default-200'
        : '',
    ]"
  >
    <!-- @slot use `EdroneTab` here as a component  -->
    <slot />
  </div>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    type?: "underline" | "border";
  }>(),
  {
    type: "underline",
  }
);
</script>
